import { useEffect, useCallback } from 'react';
import {
    useAllEventNotificationsForEntityTypeForEvent,
    useRemoveEventNotifications
} from '../../event-notifications/use-event-notifications';
import { DEFAULT_EVENT_LOCATION_NOTIFICATIONS_CLEAR_DELAY_MS } from '../constants';

interface UseEventLocationNotificationsOptions {
    delayMs?: number;
    autoClear?: boolean;
}

export const useEventLocationNotifications = (
    eventId?: number,
    options: UseEventLocationNotificationsOptions = {}
) => {
    const {
        delayMs = DEFAULT_EVENT_LOCATION_NOTIFICATIONS_CLEAR_DELAY_MS,
        autoClear = false
    } = options;

    const removeEventNotifications = useRemoveEventNotifications();

    const eventLocationNotifications = useAllEventNotificationsForEntityTypeForEvent({
        eventId,
        entityType: 'AGENCY_EVENT',
    }).filter(notification => notification.notificationType === 'EVENT_LOCATION');

    const removeEventLocationNotifications = useCallback(() => {
        eventLocationNotifications.forEach(item => {
            removeEventNotifications({
                eventId,
                entityId: item.entityId ?? eventId,
                notifications: ['EVENT_LOCATION'],
            });
        });
    }, [eventId, eventLocationNotifications, removeEventNotifications]);

    useEffect(() => {
        if (!autoClear) return;

        const timeoutId = setTimeout(() => {
            removeEventLocationNotifications();
        }, delayMs);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [autoClear, delayMs, removeEventLocationNotifications]);


    return {
        isLocationUpdated: eventLocationNotifications.length > 0,
        removeEventLocationNotifications,
        eventLocationNotifications,
    };
};
